// extracted by mini-css-extract-plugin
module.exports = {"badgeWrapper":"Badge_badgeWrapper__2R4-W","lp":"Badge_lp__h8GTP","homepage":"Badge_homepage__25nFo","hide":"Badge_hide__IJ_J6","floating":"Badge_floating__3RDhU"};